import { render, staticRenderFns } from "./ItemEditView.vue?vue&type=template&id=3cd93254&scoped=true&"
import script from "./ItemEditView.vue?vue&type=script&lang=js&"
export * from "./ItemEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd93254",
  null
  
)

export default component.exports